export default __webpack_public_path__ + "static/media/presale.0ed845f6.svg";